// Shared reveal state for commission figures, so a toggle in one place updates
// every commission display on screen. See utils/commissionVisibility.js.
import { useEffect, useReducer } from "react";
import {
  isRevealed,
  setRevealed,
  subscribe,
  commissionsVisible,
  showsRevealToggle,
} from "../utils/commissionVisibility";

export function useCommissionVisibility(user) {
  const [, bump] = useReducer((n) => n + 1, 0);

  useEffect(() => subscribe(bump), []);

  const revealed = isRevealed();
  return {
    // Should commission numbers render right now?
    visible: commissionsVisible(user, revealed),
    // Should this user get a show/hide control?
    canToggle: showsRevealToggle(user),
    revealed,
    setRevealed,
  };
}

export default useCommissionVisibility;
